import ScoreMobile from './ScoreMobile';
export default ScoreMobile;
